"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));

var _DashboardLinkSection = _interopRequireDefault(require("./DashboardLinkSection"));

var _styles = _interopRequireDefault(require("./styles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var DashboardLinks = function DashboardLinks(_ref) {
  var classes = _ref.classes,
      sections = _ref.sections;
  return /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    className: classes.dashboardLinksContainer,
    container: true,
    spacing: 4
  }, /*#__PURE__*/_react["default"].createElement(_DashboardLinkSection["default"], {
    serviceSections: sections
  }));
};

DashboardLinks.propTypes = {
  classes: _propTypes["default"].object,
  currentOffice: _propTypes["default"].object,
  email: _propTypes["default"].string,
  items: _propTypes["default"].array,
  realhubToken: _propTypes["default"].string
};

var _default = (0, _withStyles["default"])(_styles["default"])(DashboardLinks);

exports["default"] = _default;